__turbopack_context__.v({
  "content": "styles-module__e1gNDq__content",
  "contentDraft": "styles-module__e1gNDq__contentDraft",
  "loaderContainer": "styles-module__e1gNDq__loaderContainer",
  "sectionLink": "styles-module__e1gNDq__sectionLink",
});
